module.exports = __webpack_public_path__ + "static/media/logo_hg.47a43437.svg";